import { themeQuartz } from 'ag-grid-community'

export const elasticTheme = themeQuartz.withParams({
  accentColor: '#087AD1',
  backgroundColor: '#FFFFFF',
  borderColor: '#D7E2E6',
  borderRadius: 2,
  browserColorScheme: 'light',
  cellHorizontalPaddingScale: 0.7,
  chromeBackgroundColor: {
    ref: 'backgroundColor',
  },
  // columnBorder: false,
  // fontSize: 13,
  // foregroundColor: '#555B62',
  // headerBackgroundColor: '#FFFFFF',
  // headerFontSize: 13,
  // headerFontWeight: 400,
  // headerTextColor: '#84868B',
  // rowBorder: true,
  // rowVerticalPaddingScale: 2,
  // sidePanelBorder: true,
  // spacing: 6,
  // wrapperBorder: false,
  wrapperBorderRadius: 5,
})
